import { ModuleSelectionLotteryTranslation } from 'locales/de/pages/AWPM-FWPM/moduleSelectionLottery';

const en: ModuleSelectionLotteryTranslation = {
  startSuccess: 'Start of the selection lottery successful',
  startFailed:
    'Start of the selection lottery failed. It has probably already been started. Try refreshing this page.',
  precalculate: 'Calculate provisional occupancy',
  lastUpdate: 'Last update: {{date}}',
  nextScheduledUpdate: 'Next scheduled update: {{date}}',
  state: 'State: {{state}}',
  studentSignedOut: 'The student has signed out of the module'
};

export default en;
